import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getequipmentsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "equipment", ...action.payload }),
		);
		yield put({
			type: types.GET_EQUIPMENTS_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_EQUIPMENTS_ERROR,
			payload,
		});
	}
}

export function* getequipmentsWatcherSaga() {
	yield takeLatest(types.GET_EQUIPMENTS_START, getequipmentsHandlerSaga);
}

//delete

function* deleteequipmentsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("equipment", action.payload),
		);
		yield put({
			type: types.DELETE_EQUIPMENTS_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_EQUIPMENTS_ERROR,
			payload,
		});
	}
}

export function* deleteequipmentsWatcherSaga() {
	yield takeLatest(types.DELETE_EQUIPMENTS_START, deleteequipmentsHandlerSaga);
}
